import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-03-21-10-12',
  standalone: true,
  imports: [],
  templateUrl: './cp-03-21-10-12.component.html',
  styleUrl: './cp-03-21-10-12.component.scss'
})
export class Cp03211012Component {

}
